var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-by-id"},[_c('PageTitle',{attrs:{"icon":"fa fa-file-o","main":_vm.article.name,"sub":_vm.article.description}}),_c('div',{staticClass:"article-content",domProps:{"innerHTML":_vm._s(_vm.article.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }